/** Lives here for now to support tree-shaking these dynamic imports */
import { SupportedLocale } from "@outschool/localization";
import { dayjs } from "@outschool/time";

export function getDayjsLocale(locale: string) {
  // Must be written as a switch statement to support lazy loading
  switch (locale) {
    case "ko":
      return import("dayjs/locale/ko");
    default:
      return new Promise<"en">(res => res("en"));
  }
}

export async function setDayjsLocale(locale: string) {
  const dayjsLocale = await getDayjsLocale(locale);
  dayjs.locale(dayjsLocale);
}

export async function withDayjsLocale<T extends (...args: any[]) => any>(
  locale: string,
  fn: T
): Promise<ReturnType<T>> {
  const originalLocale = dayjs.locale();
  await setDayjsLocale(locale);
  let result, error;
  try {
    result = await fn();
  } catch (e) {
    error = e;
  } finally {
    await setDayjsLocale(originalLocale as SupportedLocale);
  }
  if (error) {
    throw error;
  }
  return result;
}
